import { cn } from '@/platform/lib/utils';
import { MenuSeparator as HeadlessMenuSeparator } from '@headlessui/react';

const MenuSeparator = ({ className, ...props }) => (
    <HeadlessMenuSeparator
        className={cn('my-2 h-px bg-gray-900/10', className)}
        {...props}
    />
);

export default MenuSeparator;
